import axios from 'axios'
import qs from 'qs'
import { baseUrl } from './env'

function fetch (type, url, params, baseURL) {
  type = type.toUpperCase()
  console.log(url)
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: baseURL || baseUrl,
      timeout: 8000
    })
    let fetchData = {
      method: type,
      url: url,
      data: qs.stringify(params)
    }
    console.log(fetchData)
    if (type === 'GET') {
      let dataStr = '' // 数据拼接字符串
      if (params) {
        Object.keys(params).forEach(key => {
          dataStr += key + '=' + params[key] + '&'
        })
      }
      if (dataStr !== '') {
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        url = url + '?' + dataStr
      }
      fetchData = {
        method: type,
        url: url
      }
    }
    instance(fetchData).then(response => {
      const res = response.data
      if (res.code === 6) {
        localStorage.clear()
        window.location.href = '/agent/login'
      } else {
        resolve(res)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 表单请求
function formFetch (url, params) {
  console.log(url)
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: baseUrl,
      timeout: 5000,
      headers: {'Content-Type': 'multipart/form-data'}
    })
    let fetchData = {
      method: 'POST',
      url: url,
      data: params
    }
    console.log(fetchData)
    instance(fetchData).then(response => {
      const res = response.data
      if (res.code === 6) {
        localStorage.clear()
        window.location.href = '/agent/login'
      } else {
        resolve(res)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export {
  fetch,
  formFetch
}



// WEBPACK FOOTER //
// ./src/http/axios.js